import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
const Profile = () => {
  const { user, logout } = useAuth();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Admin Profile</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage your admin account settings
        </p>
      </div>

      {/* Profile Card */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex items-start space-x-6">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-blue-600 text-2xl">👤</span>
            </div>
          </div>

          {/* User Info */}
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {user?.name || 'Admin User'}
            </h2>
            <div className="space-y-2">
              <div className="flex items-center">
                <span className="text-gray-500 w-20">Email:</span>
                <span className="text-gray-900">{user?.email || 'admin@example.com'}</span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-500 w-20">Role:</span>
                <span className="inline-flex px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
                  {user?.role || 'admin'}
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-500 w-20">Status:</span>
                <span className="inline-flex px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                  Active
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Account Actions */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Account Actions</h3>
        <div className="space-y-4">
          <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center">
              <span className="text-gray-600 text-lg mr-3">🔒</span>
              <div>
                <p className="font-medium text-gray-900">Change Password</p>
                <p className="text-sm text-gray-500">Update your password</p>
              </div>
            </div>
            <span className="text-gray-400">→</span>
          </button>

          <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
            <div className="flex items-center">
              <span className="text-gray-600 text-lg mr-3">⚙️</span>
              <div>
                <p className="font-medium text-gray-900">Account Settings</p>
                <p className="text-sm text-gray-500">Manage your preferences</p>
              </div>
            </div>
            <span className="text-gray-400">→</span>
          </button>

          <button 
            onClick={logout}
            className="w-full flex items-center justify-between p-4 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
          >
            <div className="flex items-center">
              <span className="text-red-600 text-lg mr-3">🚪</span>
              <div>
                <p className="font-medium text-red-900">Logout</p>
                <p className="text-sm text-red-700">Sign out of your account</p>
              </div>
            </div>
            <span className="text-red-400">→</span>
          </button>
        </div>
      </div>

      {/* System Info */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">System Information</h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-500">Admin Panel Version:</span>
            <span className="text-gray-900">1.0.0</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Last Login:</span>
            <span className="text-gray-900">Today at 10:30 AM</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Session Duration:</span>
            <span className="text-gray-900">2 hours 15 minutes</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile; 